/* eslint-disable @typescript-eslint/no-unnecessary-type-parameters */
export const setSessionObject = <T>(key: string, value: T): void => {
  globalThis.sessionStorage.setItem(key, JSON.stringify(value));
};

export const getSessionObject = <T>(key: string): T | null => {
  const value = globalThis.sessionStorage.getItem(key);

  return value ? (JSON.parse(value) as T) : null;
};

// export const removeSessionObject = (key: string) => {
//   globalThis.sessionStorage.removeItem(key);
// };

export const clearSession = () => {
  globalThis.sessionStorage.clear();
};
